module.exports = "<div class=\"o-footer__text\">\n    {{'copy_right' | translate:vm.values}} | {{'right_reserved' | translate}} | <a href=\"\">{{'terms_conditions' | translate}}</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/footer/footer.html
// module id = 20
// module chunks = 0